import { get } from 'lodash-es';
import { allPossiblePathOfObject } from 'src/utils/CommonUtils';

export const openInGoogleMap = ({ lat, lon }) => `https://maps.google.com/?q=${lat},${lon}`;

const buildSearchUrl = ({
    prefix = '',
    data = {},
} = {}) => {
    const uri = `https://example.com/${prefix}`;
    const url = new URL(uri);

    if (data) {
        const paths = allPossiblePathOfObject(data);

        paths.forEach((path) => {
            const value = get(data, path);
            if (value) {
                url.searchParams.set(path, value);
            }
        });

        // for (const param in data) {
        //     if (Object.prototype.hasOwnProperty.call(data, param)) {
        //         if (data[param]) {
        //             url.searchParams.set(param, data[param]);
        //         }
        //     }
        // }
    }
    return url.pathname + url.search;
};

// CITY
const citySearch = (data) => buildSearchUrl({
    prefix: 'city/search',
    data,
});
const cityManagerUrl = () => '/city/manage';

// PRODUCT
const productSearch = (data) => buildSearchUrl({
    prefix: 'product/search',
    data,
});
const productManagerUrl = () => '/product/manage';

// SINGLE MASTER
const singleMastersSearch = (data) => buildSearchUrl({
    prefix: 'masters/search',
    data,
});
const singleMastersManagerUrl = () => '/masters/manage';

// CUSTOMER
const customerSearch = (data) => buildSearchUrl({
    prefix: 'customer/search',
    data,
});
const customerManagerUrl = () => '/customer/manage';

// COMPANY
const companySearch = (data) => buildSearchUrl({
    prefix: 'company/search',
    data,
});
const companyManagerUrl = () => '/company/manage';

// COMPANY BRANCH
const companyBranchManagerUrl = (data) => buildSearchUrl({
    prefix: 'company/branch',
    data,
});

// USER
const userSearch = (data) => buildSearchUrl({
    prefix: 'user/search',
    data,
});
const userManagerUrl = () => '/user/manage';

// PERMISSIONS
const rolePermissionsUrl = () => '/permissions/role';
const userPermissionsUrl = () => '/permissions/user';

// AREA MANAGER
const areaManagerUrl = () => '/area/manage';
const areaSearch = (data) => buildSearchUrl({
    prefix: 'area/search',
    data,
});

// Catalogue MANAGER
const catalogueManagerUrl = () => '/catalogue/manage';
const catalogueSearch = (data) => buildSearchUrl({
    prefix: 'catalogue/search',
    data,
});

// Catalogue MANAGER
const commissionManagerUrl = () => '/commission/manage';
const commissionSearch = (data) => buildSearchUrl({
    prefix: 'commission/search',
    data,
});

// CASE MANAGER
const caseManagerUrl = () => '/case/manage';
const caseVehicleQuotationUrl = () => '/case/vehicle-quotation';
const caseVehicleCoverNoteUrl = () => '/case/vehicle-cover-note';
const caseVehicleInsurancePaymentUrl = () => '/case/vehicle-payments';
const CoApplicants = () => '/case/co-applicants';
const caseSearch = (data) => buildSearchUrl({
    prefix: 'case/search',
    data,
});
const caseListSearch = (data) => buildSearchUrl({
    prefix: 'reports/case-list',
    data,
});

const insuranceSearch = (data) => buildSearchUrl({
    prefix: 'reports/insurance-report',
    data,
});

const salesReportSearch = (data) => buildSearchUrl({
    prefix: 'reports/sales-report',
    data,
});

const backEndMngrSalesReportSearch = (data) => buildSearchUrl({
    prefix: 'reports/back-end-manager-sales-report',
    data,
});

// Team Target Manager
const teamTargetManagerUrl=()=>'/teamTarget/manage'
const teamTargetSearch = (data) => buildSearchUrl({
    prefix: 'teamTarget/search',
    data,
});

// insurance slab Manager
const insuranceSlabManage=()=>'/insurance-slab/manage'
const insuranceSlabSearch = (data) => buildSearchUrl({
    prefix: 'insurance-slab/search',
    data,
});

// Wallet Manager
const walletManagerUrl=()=>'/wallet/manage'
const walletSearch = (data) => buildSearchUrl({
    prefix: 'wallet/search',
    data,
});
export default {
    openInGoogleMap,
    citySearch,
    cityManagerUrl,
    productSearch,
    productManagerUrl,
    customerSearch,
    customerManagerUrl,
    companySearch,
    companyManagerUrl,
    companyBranchManagerUrl,
    userSearch,
    userManagerUrl,
    rolePermissionsUrl,
    userPermissionsUrl,
    areaManagerUrl,
    areaSearch,
    catalogueManagerUrl,
    catalogueSearch,
    commissionManagerUrl,
    commissionSearch,
    caseManagerUrl,
    caseSearch,
    caseVehicleQuotationUrl,
    caseVehicleCoverNoteUrl,
    caseVehicleInsurancePaymentUrl,
    CoApplicants,
    singleMastersSearch,
    singleMastersManagerUrl,
    teamTargetManagerUrl,
    teamTargetSearch,
    walletManagerUrl,
    walletSearch,
    caseListSearch,
    salesReportSearch,
    backEndMngrSalesReportSearch,
    insuranceSearch,
    insuranceSlabManage,
    insuranceSlabSearch,
};
